import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faHeart,
  faTimes,
  faDownload,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  faGithub,
  faLinkedin,
  faTwitter,
  faDribbble,
  faCodepen,
  faLastfm,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faArrowRight,
  faBars,
  faDownload,
  faHeart,
  faTimes,
  faGithub,
  faLinkedin,
  faTwitter,
  faDribbble,
  faCodepen,
  faLastfm
);
